export default {
    gates: [],
    workspaces: [],
    sendingsSettings: {
        workspace: null
    },
    labelsPrintHistoryElements: [],
    labelsPrintHistoryElementsLoading: false,
    printLabelsHistoryFilters: setInitialPrintLabelsHistoryFilters(),
    setInitialPrintLabelsHistoryFilters: setInitialPrintLabelsHistoryFilters,
}

function setInitialPrintLabelsHistoryFilters() {
    return {
        createdAt__gte: null,
        createdAt__lte: null,
        user_id: null
    }
}